module.exports = __webpack_public_path__ + "static/media/onboard_agencies.0186356d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/onboard_agencies.svg
// module id = 2712
// module chunks = 0